export default {
  button: {
    toMainPage: "Башкы бет",
    login: "Кирүү",
    registration: "Катталуу",
    back: "Артка",
    rcGroupWiki: "RC Group Wiki",
  },
  title: "Авторизация",
  pageTab: {
    owner: "Ээси",
    manager: "Менеджер",
  },
  form: {
    country: "Өлкө",
    mail: "Почта",
    login: "Логин",
    password: "Сырсөз",
    repeatPass: "Сырсөздү кайталаңыз",
    minInputSize: "{size} белгиден кем эмес болушу керек",
  },
  noAccount: "Аккаунтуңуз жокпу?",
  forgotPassword: "Сырсөздү унуттуңузбу?",
  dontWorryAboutForgotPass:
    "Көңүл бурбаңыз, биз почтаңызга калыбына келтирүү шилтемесин жөнөтөбүз",

  resetPass: {
    dontWorry:
      "Көңүл бурбаңыз, биз почтаңызга калыбына келтирүү шилтемесин жөнөтөбүз",
    info: {
      title: "Кирүү маалыматы почтаңызга жөнөтүлдү",
      sendedLink: "Биз сырсөздү өзгөртүү үчүн шилтемени почтаңызга жөнөттүк",
      checkSpam: "Эгер катты албай жатсаңыз, «Спам» папкасын текшериңиз",
    },
    resendMail: "Катты кайра жөнөтүү 00:%{timer} сек. ичинде",
    messageNotReceived: "Кат келген жокпу?",
    title: "Сырсөздү өзгөртүү",
    enterNewPass:
      "Жаңы сырсөздү киргизиңиз, аны жеке кабинетиңизге кирүү үчүн колдоносуз",
  },
  enterNewPassword: "Жаңы сыр сөздү киргизиңиз",
  oldLink: "Шилтеме эскирген",
  failMailCheck: "Email текшерүүдө ката кетти",
};
